import '../../App.css'
import { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { SelectGenericFromTable } from '../universal/Axios';
import { observer } from "mobx-react"
import { HandleDownload } from '../universal/IOHelper';

const AnalyticsFileTable = observer(({ network_run_id }) => {
    const queryParameters = new URLSearchParams(window.location.search)
    const id = queryParameters.get("id")
    const gen_alg_run_id = queryParameters.get("gen-alg-run-id")
    const [analyticsFiles, setAnalyticsFiles] = useState([]);
    const order_by_filename = ['channel_assignments_exploratory_Pitch_Transforms.png', 'window_si_sdr_progression.png', 'instrument_spectrogram.png', 'absorption_turn_pitch_following.png', 'rates_0_absorption_profiles.png', 'rates_1_absorption_profiles.png', 'rates_2_absorption_profiles.png']
    console.log(analyticsFiles)

    useEffect(() => {
        if (gen_alg_run_id !== null)
        {
            let query = "select * from analytics_file where gen_alg_run_id = \"" + gen_alg_run_id + "\"";
            console.log(query)
            SelectGenericFromTable("select * from analytics_file where gen_alg_run_id = \"" + gen_alg_run_id + "\"", setAnalyticsFiles)
        }
        else {
            SelectGenericFromTable("select * from analytics_file where network_run_id = \"" + id + "\"", setAnalyticsFiles)
        }
    }, []);

    if (analyticsFiles === undefined || (analyticsFiles.length > 0 && analyticsFiles[0].network_run_id !== id)) {
        return (<p>loading...</p>)
    }
    analyticsFiles.map(x => x["sort_order"] = (order_by_filename.indexOf(x.name) == -1 ? 500 : order_by_filename.indexOf(x.name)));
    analyticsFiles.sort(function (a, b) {
        return a.sort_order - b.sort_order
    });

    if (analyticsFiles.length > 0) {
        return (
            <>
                {
                    analyticsFiles.map(x =>
                        <div>
                            <span style={{ marginLeft: "10px", width: '40%', float: 'left' }}>
                                <div><i>Name: {x.name}</i></div>
                            </span>
                            <span style={{ marginLeft: "10px", float: 'left' }}>
                                <Button variant="contained" onClick={() => {
                                    HandleDownload(x.bucket, x.folder + "/", x.name)
                                }}>Download Image</Button>
                            </span>
                            <div style={{ float: "center", width: '50%' }}>
                                <img style={{ width: '350px', height: '350px' }} src={encodeURI("https://storage.googleapis.com/" + x.bucket + "/" + x.folder + "/" + x.name)}></img>
                            </div>
                            <br />
                            <br />
                        </div>)
                }
            </>
        )
    }
    else {
        return (
            <p>No analytics files have been generated for this network run.</p>
        )
    }

});

export default AnalyticsFileTable;
